<div class="multiple-auth-detail">
  <div class="multiple-auth-detail__content" *ngIf="selectedAuthenticator">
    <div class="multiple-auth-detail__form" [@fadeInOut]>
      <div class="multiple-auth-detail__form-title bz-space--stack-m">
        {{ 'AUTHENTICATION.ADD_AUTHENTICATOR' | translate }}
      </div>
      <div class="multiple-auth-detail__form-fields bz-space--stack-l">
        <div class="multiple-auth-detail__form__field  bz-space--stack-m">
          <bzg-input required [placeholder]="('AUTHENTICATION.TYPE_A_NAME' | translate) + '...'"
            [disabled]="!isEditable || isDisabled"
            [(ngModel)]="selectedAuthenticator.displayName">
            {{ 'AUTHENTICATION.DISPLAY_NAME' | translate }}
            <!--
            <bzg-required-error>
              Display name is required
            </bzg-required-error>
            -->
          </bzg-input>
        </div>
        <div class="multiple-auth-detail__form__field bz-space--stack-m">
          <div class="multiple-auth-detail__form__field__label">{{ 'AUTHENTICATION.SELECT_AUTHENTICATOR' | translate }}
          </div>
          <bzg-select name="selectAuthenticator" [placeholder]="('AUTHENTICATION.SELECT_AUTHENTICATOR_PLACEHOLDER' | translate) + '...'"
            (valueChange)="onChangeAuthenticatorType($event)" 
            [disabled]="!isEditable || isDisabled"
            [value]="selectedAuthenticator.type">
            <bzg-option *ngFor="let method of uniqueByTypeArray" [value]="method.type">
              {{ 'AUTHENTICATION.TYPE_' + method.type | translate }}
            </bzg-option>
          </bzg-select>
        </div>
        <div class="multiple-auth-detail__form__field bz-space--stack-m">
          <div></div>
          <div class="multiple-auth-detail__form__field__label">{{ 'AUTHENTICATION.SUBTYPE' | translate }}</div>

          <bzg-select name="selectSubtype" [placeholder]="('AUTHENTICATION.SELECT_SUBTYPE' | translate) + '...'" 
            [disabled]="!typeFilteredMetadataArray || typeFilteredMetadataArray.length === 0 || isDisabled " 
            (valueChange)="onChangeAuthenticatorSubtype($event)" 
            [disabled]="!isEditable || isDisabled"
            [value]="selectedAuthenticator.subtype">
            <bzg-option *ngFor="let item of typeFilteredMetadataArray" [value]="item.subtype">
              {{ item.subtype }}
            </bzg-option>
          </bzg-select>
        </div>
        <div *ngIf="selectedAuthenticator.type === 'OAuth2'" class="multiple-auth-detail__form__field bz-space--stack-m">
            <div></div>
            <div class="multiple-auth-detail__form__field__label">{{ 'AUTHENTICATION.ACTIVE_FLOW' | translate }}</div>  
            <bzg-select name="selectFlow" [placeholder]="('AUTHENTICATION.SELECT_ACTIVE_FLOW' | translate) + '...'" 
              (valueChange)="onChangeAuthenticatorFlow($event)" 
              [disabled]="!isEditable || isDisabled"
              [value]="selectedAuthenticator.oauthOptions ? selectedAuthenticator.oauthOptions.activeFlow : null">
              <bzg-option *ngFor="let flow of availableFlows" [value]="flow.name">
                {{ flow.displayName }}
              </bzg-option>
            </bzg-select>
          </div>
      </div>
      <div class="multiple-auth-detail__domains bz-space--stack-l">
        <div class="multiple-auth-detail__domains-head bz-space--stack-m">
          <div class="multiple-auth-detail__domains-head__title">
            {{ 'AUTHENTICATION.DOMAIN' | translate }}
          </div>
          <bzg-button-secondary [size]="'s'" [disabled]="!isEditable || isDisabled" (click)="domainTableAction('enable')">{{ 'AUTHENTICATION.ADD_DOMAIN' | translate }}</bzg-button-secondary>
        </div>
        <table class="bz-table" *ngIf="domainList">
          <thead>
            <tr>
              <th class="bz-table__cell bz-table__cell--sortable bmc-user-group-specific-user__cell-left">
                {{ 'AUTHENTICATION.DOMAIN' | translate}}
              </th>
              <th class="bz-table__cell bz-table__cell--sortable">
                {{ 'AUTHENTICATION.DISPLAY_NAME' | translate}}
              </th>
              <th class="bz-table__cell bz-table__cell--sortable">
                {{'AUTHENTICATION.ACTIONS' | translate}}
              </th>

            </tr>
          </thead>
          <tbody>
            <tr *ngIf="showAddDomain">
              <td class="bz-table__cell">
                <bzg-input id="displayName" (paste)="validateDomainNamePaste($event)" (keypress)="validateDomainNameKey($event)" [placeholder]="('AUTHENTICATION.TYPE_A_DOMAIN' | translate) + '...'" [maxlength]="40" [(ngModel)]="newDomainValue">
                </bzg-input>
              </td>
              <td class="bz-table__cell">
                <bzg-input id="displayName" [placeholder]="('AUTHENTICATION.TYPE_A_NAME' | translate) + '...'" [maxlength]="40" [(ngModel)]="newDomainDisplayName">
                </bzg-input>
              </td>
              <td class="bz-table__cell">
                <div class="multiple-auth-detail__domains-table__actions">
                  <bzg-button-icon icon="icon-check-mark" [filled]="true" class="bz-space--inline-s" (click)="domainTableAction('add')"></bzg-button-icon>
                  <bzg-button-icon icon="icon-delete" (click)="domainTableAction('disable')"></bzg-button-icon>
                </div>
              </td>
            </tr>
            <tr *ngFor="let item of domainList">

              <td class="bz-table__cell">
                <label *ngIf="editModeDomain !== item">{{ item.name }}</label>
                <bzg-input id="nameEditor" (paste)="validateDomainNamePaste($event)" (keypress)="validateDomainNameKey($event)" *ngIf="editModeDomain === item" [placeholder]="('AUTHENTICATION.TYPE_A_DOMAIN' | translate) + '...'" 
                          [maxlength]="40" [(ngModel)]="item.name">
                </bzg-input>
              </td>
              <td class="bz-table__cell">
                <label *ngIf="editModeDomain !== item">{{ item.displayName }}</label>
                <bzg-input id="displayNameEditor" *ngIf="editModeDomain === item" [placeholder]="('AUTHENTICATION.TYPE_A_NAME' | translate) + '...'" 
                          [maxlength]="40" [(ngModel)]="item.displayName">
                </bzg-input>
              </td>
              <td class="bz-table__cell">
                <div class="multiple-auth-detail__domains-table__actions">
                  <bzg-button-icon icon="icon-edit" *ngIf="editModeDomain !== item"
                                  [disabled]="!isEditable || isDisabled" class="bz-space--inline-s" 
                                  (click)="editModeDomain = item">
                  </bzg-button-icon>
                  <bzg-button-icon icon="icon-check-mark" *ngIf="editModeDomain === item" 
                                  [disabled]="!isEditable || isDisabled" class="filled-button bz-space--inline-s" 
                                  (click)="editModeDomain = null">
                  </bzg-button-icon>
                  <bzg-button-icon icon="icon-delete" [disabled]="!isEditable || isDisabled" (click)="deleteDomain(item)"></bzg-button-icon>
                </div>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="bz-divider bz-divider--horizontal bz-space--stack-m"></div>
    <div class="multiple-auth-detail__actions">
      <bzg-button-primary [disabled]="!selectedAuthenticator.domains.length || !isFormValid()" *ngIf="viewMode == 0" (click)="setNewAuthenticator()">{{ 'GLOBAL.ADD' | translate }}</bzg-button-primary>
      <bzg-button-primary *ngIf="viewMode == 1" [disabled]="!isEditable || !isFormValid() || isDisabled" (click)="updateAuthenticator()">{{ 'GLOBAL.SAVE' | translate }}</bzg-button-primary>
      <bzg-button-secondary class="bz-space--inline-s" [disabled]="!isEditable" (click)="cancel()">{{ 'GLOBAL.CANCEL' | translate }}</bzg-button-secondary>
    </div>
  </div>
  <div class="multiple-auth-detail__empty-msg" *ngIf="!selectedAuthenticator">
    <strong class="bz-color--neutral-500" [@fadeInOut]>{{ 'AUTHENTICATION.MULTIPLE_LIST_UNSELECT_MSG' | translate }}</strong>
  </div>
</div>
